import {React, useState, useLayoutEffect} from "react";
import styled, { keyframes } from "styled-components";
import headerImg from './img/headerbackground.jpg';


let status = "offline";
let sensZitting = "Er zit niemand"
let time = 0
let score = 0;


const ws = new WebSocket('wss://fox-connect.nl:4084/settings');  //'wss://stepverder.nl:4084/controller' 'wss://fox-connect.nl:6000'

ws.onopen = (event) => {
  console.log("connection is open")
  ws.send(JSON.stringify("Hallo sensor ik ben de telefoon"));
};

ws.onmessage = function (event) {
  try {
   
      console.log(event.data)
  } catch (err) {
    console.log(err);
  }
};

ws.onerror = (e) => {
  // an error occurred
  console.log(e.message);
};

//background: linear-gradient(45deg, ${color1} ${props => props.position1}%, ${color2} ${props => props.position2}%);


const StyledZitting = styled.div`
color: white;
position: relative;
  background: #333b47;
  width: 100%;
  height: 100vh;
  overflow:hidden;
  font-family: 'Rajdhani', sans-serif;

  h1{
      padding-top: 50px;
  }

  button{
      margin: 20px;
  }

`


function Zitting() {


  return (

      <StyledZitting  >
    
          <h1>Zit overzicht</h1>
          <div className="realtime">
              <h2>Realtime</h2>
              <p>Status: {status}</p>
              <p>Positie: {sensZitting}</p>
              <p>Score:  {score}</p>
          </div>

         <h1>Geschiedenis</h1>
          <button>Dag overzicht</button>
          <button>Week</button>
          <button>Maand</button>

         <div className="dayTime">

         </div>
         <div className="Weekly">

         </div>
         <div className="altime">

         </div>
         <h1>Advies</h1>

          <button>Test mat</button>
      
        
    
      </StyledZitting>
  );
}
export default Zitting;